<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>
        {{ 'DISTRIBUTION.batch.model_name.singular' | translate }}:
        <span *ngIf="distributionBatch">{{ distributionBatch.name }}</span>
        <small *ngIf="distributionBatch">
          <!--<span class="badge badge-info">{{ distributionBatch.status }}</span>-->
          ({{ 'DISTRIBUTION.batch.detail.subheading_date_label' | translate}}:
          {{ distributionBatch.submitted_at ? (distributionBatch.submitted_at | date) : 'N/A' }})
        </small>
      </h1>
      <div *ngIf="!batchTotalAmounts">
        <mat-progress-bar class="cash-hurdle-progress" mode="indeterminate"></mat-progress-bar>
      </div>
      <div *ngIf="batchTotalAmounts" class="d-flex justify-content-center mt-1">
        <div>
          <div class="text-center">
            <small>Debt plan</small>
          </div>
          <mat-progress-bar class="cash-hurdle-progress" mode="determinate"
                            [value]="batchTotalAmounts.total_distributed_amount / (batchTotalAmounts.total_batch_contract_amount / 100)">
          </mat-progress-bar>
          <div class="text-center">
            <small>
              {{ batchTotalAmounts.total_distributed_amount | currency: 'EUR' }} /
              {{ batchTotalAmounts.total_batch_contract_amount | currency: 'EUR' }}
            </small>
          </div>
        </div>
        <!--<div *ngIf="componentType === 'admin'" class="ml-3">
          <div class="text-center">
            <small>{{ 'DISTRIBUTION.batch.detail.total_progress_bar.fees_retained' | translate }}</small>
          </div>
          <mat-progress-bar class="fees-retained-progress" mode="determinate" color="accent"
                            [value]="batchTotalAmounts.total_fees_retained / (batchTotalAmounts.total_fees_obtainable / 100)">
          </mat-progress-bar>
          <div class="text-center">
            <small>
              {{ batchTotalAmounts.total_fees_retained | currency: 'EUR' }} /
              {{ batchTotalAmounts.total_fees_obtainable | currency: 'EUR' }}
            </small>
          </div>
        </div>-->
        <div *ngIf="componentType === 'distribution'" class="ml-3">
          <div class="text-center">
            <small>{{ 'DISTRIBUTION.batch.detail.total_progress_bar.fees_retained' | translate }}</small>
          </div>
          <mat-progress-bar class="fees-retained-progress" mode="determinate" color="accent"
                            [value]="batchTotalAmounts.total_provider_fees_retained / (batchTotalAmounts.total_provider_fees_obtainable / 100)">
          </mat-progress-bar>
          <div class="text-center">
            <small>
              {{ batchTotalAmounts.total_provider_fees_retained | currency: 'EUR' }} /
              {{ batchTotalAmounts.total_provider_fees_obtainable | currency: 'EUR' }}
            </small>
          </div>
        </div>
      </div>
    </mat-card-title>
    <div class="header-actions">
      <a mat-raised-button [routerLink]="componentType === 'admin' ?
      ['/distribution', 'batches'] : ['/distribution-provider', 'batches']">
        {{ 'SHARED.back' | translate }}
      </a>
      <a *ngIf="componentType === 'admin' && distributionBatch" mat-raised-button color="primary" class="ml-3"
         [routerLink]="['/distribution', 'batches', distributionBatch.id, 'edit']">
        {{ "SHARED.edit" | translate }}
      </a>
      <button *ngIf="authUser?.role_id === 5 && componentType === 'admin'" mat-raised-button class="ml-3"
              (click)="changeComponentType('distribution')">
        {{ 'DISTRIBUTION.batch.detail.actions.show_provider_view' | translate }}
      </button>
      <button *ngIf="authUser?.role_id === 5 && componentType === 'distribution'" mat-raised-button class="ml-3"
              (click)="changeComponentType('admin')">
        {{ 'DISTRIBUTION.batch.detail.actions.show_admin_view' | translate }}
      </button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <!-- Filters -->
    <div class="d-flex justify-content-end">
      <app-input type="text" [formControl]="searchFilter" [appearance]="'standard'"
                 [label]="'SHARED.search' | translate" [extraLabel]="false" prefixType="icon" prefix="search">
      </app-input>
    </div>
    <!-- Filters -->
    <mat-expansion-panel class="mb-3">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "PAYMENTS.advanced-filters" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row">
        <!-- Payment Status -->
        <!--<div class="col-4">
          <app-input type="select" [formControl]="paymentStatusFilter" appearance="outline" fullWidth="false" multiple
                     [label]="'CASES.single.general.status_editor.payment_status' | translate"
                     [selectOptions]="paymentStatuses" [selectLabel]="'name'" [selectValue]="'id'">
          </app-input>
        </div>-->
        <!-- Case Status -->
        <!--<div class="col-4">
          <app-input type="select" [formControl]="caseStatusFilter" appearance="outline" [fullWidth]="true"
                     [label]="'CONFIG.drip-campaign.editor.statusable_id.label' | translate" multiple
                     [selectOptions]="statusCategories" [optGroupProperty]="'statuses'" [optGroupLabel]="'name'"
                     [selectLabel]="'name'" [selectValue]="'id'">
          </app-input>
        </div>-->
        <!-- Cases ID -->
        <div class="col-4">
          <app-input type="select" [formControl]="casesFilter" appearance="outline" multiple fullWidth="false"
                     [searchable]="true"
                     [label]="'Cases'"
                     [selectOptions]="cases" 
                     [selectLabel]="'ref_number'" 
                     [selectValue]="'id'">
          </app-input>
        </div>
      </div>
    </mat-expansion-panel>
    <!-- Table List -->
    <mat-card appearance="outlined" class="mat-elevation-z3">
      <mat-card-content>
        <app-server-response *ngIf="serverResponse" [response]="serverResponse"></app-server-response>
        <mat-table [dataSource]="caseDistributions" matSort (matSortChange)="sortData($event)" style="vertical-align: middle">
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <!-- Case Distribution Batch Index -->
          <ng-container matColumnDef="batch_index">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.index" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              <span [matTooltip]="element.entered_batch_at | date:'d MMM y, HH:mm'">{{ element.batch_index }}</span>
            </td>
          </ng-container>
          <!-- Case Ref Number -->
          <ng-container matColumnDef="case_ref_number">
            <th mat-header-cell *matHeaderCellDef>
              {{ "CASES.model.ref_number" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              <!--<pre>{{ element | json }}</pre>-->
              <a *ngIf="componentType === 'admin'" [routerLink]="['/cases', element.case_id]">
                {{ element.case_id }}
              </a>
              <!--<a *ngIf="componentType === 'distribution'" [routerLink]="[element.case.uuid, 'payments']">
                {{ element.case_id }}
              </a>-->
            </td>
          </ng-container>
          
          <!-- Status -->
          <!--<ng-container matColumnDef="case_status">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'DISTRIBUTION.batch.detail.cases_table.case_status' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.case.status?.name }}
            </td>
          </ng-container>-->

          <ng-container matColumnDef="plan_start_date">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.plan_start_date" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.case.debt_payment_plan?.phase2_start_from | date }}
            </td>
          </ng-container>
          
          <!-- Status Updated At -->
          <!--<ng-container matColumnDef="case_status_updated_at">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'DISTRIBUTION.batch.detail.cases_table.case_status_updated_at' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.case.latest_case_status_log?.created_at | date }}
            </td>
          </ng-container>-->

          <!-- Plan End date -->
          <ng-container matColumnDef="plan_end_date">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.plan_end_date" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.c_payment_end_date | date }}
            </td>
          </ng-container>

          <!-- Payment Status -->
          <ng-container matColumnDef="case_payment_status">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ 'DISTRIBUTION.batch.detail.cases_table.case_payment_status' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" >
              {{ element.case.payment_status?.name }}
            </td>
          </ng-container>

          <!-- Monthly Fee Amount -->
          <ng-container matColumnDef="monthly_fee_amount">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.inst_amt" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.installment_amt | currency: 'EUR' }}
            </td>
          </ng-container>

          <!-- Batch Contract Amount -->
          <!--<ng-container matColumnDef="batch_contract_amount">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ 'DISTRIBUTION.cases.list.table.contract_amount' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              {{ element.batch_contract_amount  | currency:'EUR' }}
            </td>
          </ng-container>-->

          <!-- Debt Plan Total -->
          <ng-container matColumnDef="debt_plan_total">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.debt_plan_total" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              {{ element.c_debt_plan_total  | currency:'EUR' }}
            </td>
          </ng-container>

          <!-- Distributed Amount -->
          <ng-container matColumnDef="distributed_amount">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ 'DISTRIBUTION.batch.detail.cases_table.distributed_amount' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              {{ element.distributed_amount  | currency:'EUR' }}
            </td>
          </ng-container>

          <!-- Funded Amount -->
          <ng-container matColumnDef="funded_amount">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ 'DISTRIBUTION.batch.detail.cases_table.funding_amount' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              {{ element.funded_amount  | currency:'EUR' }}
            </td>
          </ng-container>

          <!-- Cash Hurdle Amount -->
          <ng-container matColumnDef="cash_hurdle_amount">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ 'DISTRIBUTION.batch.detail.cases_table.cash_hurdle_amount' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              {{ element.cash_hurdle_amount  | currency:'EUR' }}
            </td>
          </ng-container>

          <!-- Fees Retained -->
          <ng-container matColumnDef="fees_retained">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ 'DISTRIBUTION.batch.detail.cases_table.fees_retained' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              <span *ngIf="componentType ==='admin'">{{ element.fees_retained  | currency:'EUR' }}</span>
              <span *ngIf="componentType ==='distribution'">
                {{ element.provider_fees_retained  | currency:'EUR' }}
              </span>
            </td>
          </ng-container>

          <!-- ID Card -->
          <ng-container matColumnDef="id_card">
            <th mat-header-cell *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.id_card" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
                {{ element.id_card }}
            </td>
          </ng-container>

          <!-- REF Number -->
          <ng-container matColumnDef="ref_number">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.ref_number" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <a [routerLink]="['/cases', element.case_id]">{{ element.ref_number }}</a>
            </td>
          </ng-container>

          <!-- term -->
          <ng-container matColumnDef="term">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.term" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
                {{ element.term }}
            </td>
          </ng-container>

          <!-- Collected Amt -->
          <ng-container matColumnDef="collected_amt">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.collected_amt" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
                {{ element.collected_amt | currency:'EUR' }}
            </td>
          </ng-container>

          <!-- Balance -->
          <ng-container matColumnDef="current_balance">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.balance" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
                <!-- {{ element.current_balance }} -->
                {{ (element.orig_balance - element.collected_amt) | currency:'EUR' }}
            </td>
          </ng-container>

          <!-- Distributed Amount -->
          <ng-container matColumnDef="distributed_amt">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.distributed_amt" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
                {{ element.distributed_amt | currency:'EUR' }}
            </td>
          </ng-container>

          <!-- Distribution pending -->
          <ng-container matColumnDef="pending_dist">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.dist_pending" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
                <!--{{ element.pending_dist }}-->
                {{ (element.collected_amt - element.distributed_amt - element.c_on_hold) | currency:'EUR' }}
            </td>
          </ng-container>

          <!-- Original Balance -->
          <ng-container matColumnDef="orig_balance">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ "DISTRIBUTION.batch-detail.orig_balance" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
                {{ element.orig_balance | currency:'EUR' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="on-account">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="pl-2">
              <!--{{ 'DISTRIBUTION.batch-list.pending_distribution' | translate }}-->
              On-account
            </th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              {{ (element.c_on_hold || 0) | currency:'EUR' }}
            </td>
          </ng-container>

          <!-- Contract Download -->
          <!--<ng-container matColumnDef="contract_download">
            <th mat-header-cell *matHeaderCellDef>{{ 'DISTRIBUTION.batch.detail.cases_table.contract_download' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              <a *ngIf="element.case.latest_contract?.pdf_location" mat-raised-button target="_blank" class="mt-1 mb-1"
                 href="{{storageUrl + element.case.latest_contract.pdf_location}}">
                {{ 'DISTRIBUTION.batch.detail.cases_table.contract_download' | translate }}
              </a>
            </td>
          </ng-container>-->

          <ng-container matColumnDef="contract_download">
            <th mat-header-cell *matHeaderCellDef>Proposal</th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              <a *ngIf="element.c_proposal_location" 
                mat-raised-button 
                target="_blank" 
                class="mt-1 mb-1 proposal-button"
                href="{{storageUrl + element.c_proposal_location}}">
                {{ "DISTRIBUTION.batch-detail.proposal" | translate }}
              </a>
              <!--<span *ngIf="!element.case.latest_contract?.pdf_location">&nbsp;</span>-->
            </td>
          </ng-container>

          <!-- Progress -->
          <ng-container matColumnDef="progress_bar">
            <th mat-header-cell
                *matHeaderCellDef>{{ 'DISTRIBUTION.batch.detail.cases_table.progress' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="pr-2">
              <div class="d-flex justify-content-center mt-3">
                <mat-progress-bar class="cash-hurdle-progress" mode="determinate"
                                  [matTooltip]="(element.distributed_amount | currency:'EUR') + ' / ' +
                                   (element.cash_hurdle_amount | currency:'EUR')"
                                  [value]="element.distributed_amount / (element.cash_hurdle_amount / 100)">
                </mat-progress-bar>
                <mat-progress-bar *ngIf="componentType === 'admin'" class="fees-retained-progress" mode="determinate"
                                  color="accent" [matTooltip]="(element.fees_retained | currency:'EUR') + ' / ' +
                                   (element.fees_obtainable | currency:'EUR')"
                                  [value]="element.fees_retained / (element.fees_obtainable / 100)">
                </mat-progress-bar>
                <mat-progress-bar *ngIf="componentType === 'distribution'" class="fees-retained-progress"
                                  mode="determinate" color="accent"
                                  [matTooltip]="(element.provider_fees_retained | currency:'EUR') + ' / ' +
                                   (element.provider_fees_obtainable | currency:'EUR')"
                                  [value]="element.provider_fees_retained / (element.provider_fees_obtainable / 100)">
                </mat-progress-bar>
              </div>
            </td>
          </ng-container>
        </mat-table>
        <!-- No Data -->
        <div *ngIf="isLoading < 1 && caseDistributions && caseDistributions.data.length < 1" style="padding: 50px">
          <h3 class="text-center">{{ "CASES.no-cases" | translate }}</h3>
        </div>
        <div *ngIf="isLoading" class="text-center" style="padding: 50px">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </mat-card-content>
      <mat-card-footer>
        <div class="footer-actions ml-3">
          <!--<button *ngIf="componentType === 'admin'" mat-raised-button color="primary"-->
          <!--        [disabled]="selection.selected.length === 0" (click)="downloadContracts(distributionBatch)">-->
          <!--  {{ 'DISTRIBUTION.batch.detail.table_actions.download_all_contracts' | translate }}-->
          <!--</button>-->
        </div>
        <mat-paginator [length]="paginatorConfig.length" [pageSize]="paginatorConfig.pageSize" showFirstLastButtons
                       [pageSizeOptions]="[1, 5, 10, 20, 50, 100]" [pageIndex]="paginatorConfig.pageIndex"
                       (page)="paginatorChange($event)">
        </mat-paginator>
      </mat-card-footer>
    </mat-card>
  </mat-card-content>
</mat-card>
